import { useRoutes } from '@folklore/routes';
import { Route, Switch, useLocation } from 'wouter';

import usePage from '../hooks/usePage';

import MainLayout from './layouts/Main';
import ErrorPage from './pages/Error';
import HomePage from './pages/Home';
import LoaderPage from './pages/LoaderPage';

import '../../styles/styles.css';

function Routes() {
    const [pathname] = useLocation();
    const routes = useRoutes() || {};

    const { page = null, loading = false, refetch = null, status, error } = usePage(pathname);

    const isError = status === 'error' && error !== null && !loading;

    return (
        <Switch>
            <Route path={routes.home || '/'}>
                <MainLayout loading={loading} refetch={refetch} page={page} isError={isError}>
                    <HomePage page={page} loading={loading} />
                </MainLayout>
            </Route>
            <Route path={routes['pages.show']}>
                <MainLayout loading={loading} refetch={refetch} page={page} isError={isError}>
                    <LoaderPage page={page} loading={loading} error={error} />
                </MainLayout>
            </Route>
            <Route path={routes['pages.show_with_parent']}>
                <MainLayout loading={loading} refetch={refetch} page={page} isError={isError}>
                    <LoaderPage page={page} loading={loading} error={error} />
                </MainLayout>
            </Route>
            <Route path={routes['pages.event']}>
                <MainLayout loading={loading} refetch={refetch} page={page} isError={isError}>
                    <LoaderPage page={page} loading={loading} error={error} />
                </MainLayout>
            </Route>
            <Route path="*">
                <MainLayout loading={loading} refetch={refetch} page={page} isError={isError}>
                    <ErrorPage loading={loading} />
                </MainLayout>
            </Route>
        </Switch>
    );
}

export default Routes;
